document.addEventListener("DOMContentLoaded", function () {
  const scentDescriptions = {
    "Archimedes' Clear": "A clean, unadorned formula that honors simplicity — gentle, scentless, and thoughtfully refined.",
    "DaVinci's Orchard": "A sophisticated blend of pear, warm woods, and subtle spice, Da Vinci's Orchard evokes the brilliance of Renaissance creativity and timeless elegance.",
    "Drake's Voyage": "A bold, spiced blend of bay rum and wild berries, Drake's Voyage captures the thrill of uncharted waters and the daring spirit of discovery.",
    "Edison's Enlightenment": "A captivating and bold fragrance, Edison's Enlightenment combines the spicy zest of ginger and pepper with herbal notes of basil and sage, settling into a deep, woody base of cedar, amber, patchouli, redwood, and soft suede.",
    "Einstein's Elixer": "A sharp, magnetic blend of ginger, woods, and amber, Einstein's Elixer channels bold ideas and quiet confidence into a scent built for visionaries.",
    "Franklin's Reserve": "Inspired by Benjamin Franklin, Franklin's Reserve is a sophisticated and indulgent blend of smooth Tennessee whiskey, warm caramel, delicate strawberry wine, and refined brandy undertones, evoking fireside chats and well-crafted inventions.",
    "Freud's Study": "A rich, masculine blend of sweet woods and fresh-cut tobacco, Freud's Study evokes the quiet elegance of a scholarly mind at rest.",
    "Galileo's Harvest": "A bright medley of apple, mandarin, and warm spice, Galileo's Harvest captures the crisp energy of autumn and the boundless spirit of discovery.",
    "Guinness' Craft": "A warm, earthy blend of hops, almond, oatmeal, and orange peel, this scent pays tribute to timeless craftsmanship and the comforting richness of a well-brewed life.",
    "Jimmy's Escape": "A breezy blend of pineapple and coconut, this sun-soaked scent channels carefree island days and the endless warmth of summer.",
    "Marquez's Magic": "A scent that blends bold amber, teakwood, coffee beans, and smooth leather with bright notes of lemon, bergamot, and vetiver—smart, sultry, and a little bit legendary.",
    "Newton's Notions": "A refreshing and bold fragrance, Newton's Notions blends vibrant apple with deep oak, reflecting Sir Isaac Newton's curious mind and revolutionary ideas.",
    "Ramanujan's Calm": "Inspired by Srinivasa Ramanujan, Ramanujan's Calm is a harmonious and meditative blend of bright bergamot, earthy patchouli, warm sandalwood, and soft musk, embodying quiet depth and contemplative clarity.",
    "Tagore's Terra": "Inspired by Rabindranath Tagore, Tagore's Terra is a deeply earthy and meditative scent with notes.of patchouli, woodland greens, and incense, evoking India's lush landscapes and spiritual tranquility.",
    "Tesla's Temptation": "Inspired by Nikola Tesla, Tesla's Temptation is a sophisticated and intriguing fragrance for the modern man, balancing boldness and subtlety with an elegant, luxury cologne profile reminiscent of a certain 'Guilty' fragrance.",
    "Thoreau's Haven": "A calming blend of cedar and sage, reminiscent of quiet woods and thoughtful solitude.",
    "Ada's Spark": "Inspired by Ada Lovelace, Ada's Spark is an inspiring and elegant scent, combining fresh citrus and fruity notes with a soft hint of vanilla.",
    "Fanny's Resolve": "Inspired by resilience and compassion, Fanny's Resolve is a light and airy fragrance of coconut and vanilla, perfect for women of calm strength.",
    "Lili'u's Legacy": "Liliʻu's Legacy is a vibrant, tropical fragrance that blends delicate florals, juicy melon, and sweet berries with a refreshing ocean breeze, evoking the spirit of Hawaii and celebrating strength and grace.",
    "Rosa's Stand": "Inspired by Rosa Parks, Rosa's Stand is an uplifting fragrance that combines clementine leaves, orange blossom, and water lily, perfect for women who lead with strength and elegance.",
    "Hedy's Frequency": "Hedy's Frequency is a comforting and nurturing blend of wheaty oatmeal, warm cream, and soothing honey, celebrating brilliance and innovation while offering a grounding scent."
  };

  // *** FIX #1: Add flag to prevent infinite loop ***
  let isUpdating = false;

  // Debounce function to limit how often a function is called
  const debounce = (func, delay) => {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const debouncedUpdateScentDescriptionBox = debounce(function() {
    // *** FIX #2: Check flag and exit if already updating ***
    if (isUpdating) {
      console.log("Beard Bright Scent Descriptions: Update already in progress, skipping.");
      return;
    }

    // *** FIX #3: Set flag to true while updating ***
    isUpdating = true;
    
    console.log("Beard Bright Scent Descriptions: Debounced update called.");

    const scentSelect = document.querySelector('select[name="options[Scent]"]') ||
                        document.querySelector('select[name="options[Belle Bright Scent]"]');

    if (!scentSelect) {
        console.log("Beard Bright Scent Descriptions: Scent select not found during debounced update.");
        isUpdating = false; // *** Reset flag before returning ***
        return;
    }

    const insertionPoint = scentSelect.closest('.variant-option--dropdowns, .variant-option, .variant-option__item, .product-form__input, .selector-wrapper, .product-form__controls-group, .product-form__controls, .product-form__item, .product-form__variant-selector');

    if (!insertionPoint) {
      console.log("Beard Bright Scent Descriptions: No suitable insertion point found for description box.");
      isUpdating = false; // *** Reset flag before returning ***
      return;
    }

    let descriptionBox = document.getElementById("scent-description-box");

    // Re-create and re-insert logic
    if (!descriptionBox || !insertionPoint.nextElementSibling || insertionPoint.nextElementSibling.id !== "scent-description-box") {
      if (descriptionBox) {
          descriptionBox.remove();
          console.log("Beard Bright Scent Descriptions: Existing description box removed (likely detached or moved).");
      }
      descriptionBox = document.createElement("div");
      descriptionBox.id = "scent-description-box";
      descriptionBox.style.marginTop = "10px";
      descriptionBox.style.backgroundColor = "#f8f8f8";
      descriptionBox.style.color = "#333";
      descriptionBox.style.border = "2px solid #000";
      descriptionBox.style.borderRadius = "8px";
      descriptionBox.style.padding = "10px 15px";
      descriptionBox.style.fontStyle = "italic";
      descriptionBox.style.boxShadow = "1px 1px 3px rgba(0, 0, 0, 0.1)";

      insertionPoint.insertAdjacentElement("afterend", descriptionBox);
      console.log("Beard Bright Scent Descriptions: Description box re-created and inserted after:", insertionPoint.className || insertionPoint.tagName);
    } else {
      console.log("Beard Bright Scent Descriptions: Description box found and reusing.");
    }

    const selectedScentValue = scentSelect.value.trim();
    const descriptionText = scentDescriptions[selectedScentValue];

    // *** FIX #4: Stock count function - only run if stock box exists ***
    function updateStockCount(selectedVariantId) {
      const stockBox = document.getElementById("variant-stock-count");
      if (!stockBox) {
        // *** REMOVED console.warn - this was spamming your console ***
        // Stock box is optional, so just skip silently if not present
        return;
      }

      if (!window.variantData || !Array.isArray(window.variantData)) {
        console.warn("window.variantData is missing or not an array.");
        stockBox.textContent = "";
        return;
      }

      const matchingVariant = window.variantData.find(v => v.id == selectedVariantId);

      if (matchingVariant && typeof matchingVariant.inventory_quantity === "number") {
        const qty = matchingVariant.inventory_quantity;
        stockBox.textContent = qty > 0 ? `In stock: ${qty}` : "Out of stock";
        stockBox.style.color = qty > 0 ? "#006400" : "#B22222";
        console.log(`Stock for variant ID ${selectedVariantId}: ${qty}`);
      } else {
        stockBox.textContent = "";
      }
    }

    const selectedVariantId = parseInt(document.querySelector('select[name="id"]')?.value, 10);
    if (selectedVariantId) {
      updateStockCount(selectedVariantId);
    }
    
    if (descriptionText) {
      descriptionBox.innerHTML = `<strong>Scent Profile:</strong> ${descriptionText}`;
      descriptionBox.style.display = "block";
      console.log(`Beard Bright Scent Descriptions: Displaying description for: ${selectedScentValue}`);
    } else {
      descriptionBox.innerHTML = "";
      descriptionBox.style.display = "none";
      console.log(`Beard Bright Scent Descriptions: No description found for: ${selectedScentValue}, hiding box.`);
    }

    // *** FIX #5: Reset flag after a short delay to allow DOM to settle ***
    setTimeout(() => {
      isUpdating = false;
      console.log("Beard Bright Scent Descriptions: Update complete, ready for next update.");
    }, 200);

  }, 150); // Debounce delay

  // --- Initial Setup and Event Listeners ---

  debouncedUpdateScentDescriptionBox();
  console.log("Beard Bright Scent Descriptions: Initial debouncedUpdateScentDescriptionBox call scheduled.");

  document.addEventListener("change", function(event) {
    if (event.target && (event.target.name === "options[Scent]" || event.target.name === "options[Belle Bright Scent]")) {
      debouncedUpdateScentDescriptionBox();
      console.log("Beard Bright Scent Descriptions: Scent dropdown 'change' event detected.");
    }
  });

  // *** FIX #6: More specific MutationObserver configuration ***
  const productFormContainer = document.getElementById("ProductInformation-template--16998961873005__main");

  if (productFormContainer) {
    console.log("Beard Bright Scent Descriptions: MutationObserver target found:", productFormContainer.className || productFormContainer.tagName || productFormContainer.id);
    const observer = new MutationObserver(function(mutations) {
      // *** Only trigger if the mutation is NOT from our own scent description box ***
      const isOurOwnUpdate = mutations.some(mutation => {
        return mutation.target.id === 'scent-description-box' ||
               (mutation.target.parentElement && mutation.target.parentElement.id === 'scent-description-box') ||
               (mutation.addedNodes && Array.from(mutation.addedNodes).some(node => node.id === 'scent-description-box'));
      });

      if (!isOurOwnUpdate) {
        debouncedUpdateScentDescriptionBox();
      }
    });

    // *** More selective observation - only watch for specific changes ***
    observer.observe(productFormContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-variant-id'] // Only watch relevant attributes
    });
  } else {
    console.warn("Beard Bright Scent Descriptions: Could not find a suitable product form container for MutationObserver.");
  }

  document.addEventListener('shopify:section:load', function(event) {
    console.log(`Beard Bright Scent Descriptions: 'shopify:section:load' for section ${event.detail.sectionId} detected.`);
    if (event.detail && (event.detail.sectionId.includes('product') || event.detail.sectionId.includes('main-product') || event.detail.sectionId.includes('template-product'))) {
      debouncedUpdateScentDescriptionBox();
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    if (event.detail && event.detail.blockId) {
        debouncedUpdateScentDescriptionBox();
        console.log("Beard Bright Scent Descriptions: 'shopify:block:select' detected.");
    }
  });

  document.addEventListener('shopify:variant:change', function(event) {
      debouncedUpdateScentDescriptionBox();
      console.log("Beard Bright Scent Descriptions: 'shopify:variant:change' event detected.");
  });
});